import { render, staticRenderFns } from "./TermoAvg.vue?vue&type=template&id=10cb8a6e&scoped=true&"
import script from "./TermoAvg.vue?vue&type=script&lang=js&"
export * from "./TermoAvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb8a6e",
  null
  
)

export default component.exports